import {Routes} from '@angular/router';
import {LoginPageComponent} from './login-page.component';
import {ForgotLoginPageComponent} from './forgot/forgot-login-page.component';
import {ResetPasswordPageComponent} from './reset-password/reset-password-page.component';
import {AuthInfo} from '../../components/security/authorization/auth.guard';

/**
 * Created by Rodrigo Quesada on 24/11/16.
 */
const routes: Routes = [{
    path: 'login',
    data: {auth: new AuthInfo({allowUnauthorizedUsers: true}), withSectionNav: false},
    children: [
        {path: '', component: LoginPageComponent},
        {path: 'forgot', component: ForgotLoginPageComponent},
        {path: 'reset-password', component: ResetPasswordPageComponent}
    ]
}];
export default routes;



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/pages/login/login-page.routing.ts